export default __webpack_public_path__ + "static/media/step7_img1.6ae9a0ad.png";